<template lang='pug'>
div
    ServicesSelectorLinks
    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title Entwicklung von individueller Messtechnik
            .subtitle Wir entwickeln mit Ihnen gemeinsam oder für Sie individuell an Ihre Anforderungen angepasste Messtechnik.

        div.margin-bottom
            .column-container
                .column.center-content
                    //- Carousel(:perPage="1", autoplay=true, :autoplayTimeout="4000", loop=true, :centerMode="true", navigationEnabled=false, paginationPosition='bottom-overlay', paginationColor='rgba(255,255,255,0.4)', paginationActiveColor='#FAFAFA', adjustableHeight=false)
                    //-     Slide
                    //-         div.image-container
                    //-             picture
                    img( src='@/assets/svg/CustomDevices.svg', alt='Individuelle Messtechnik', title='Individuelle Messtechnik')

                    
                .column.factsandbluebox
                    .factbox
                        //.span.headline Beispiele:
                        //ul
                        p Im Rahmen zahlreicher Forschungs- und Entwicklungsprojekte hat die BSS Messtechnik in der kompletten Kette von der Sensorik über die A/D Wandlung bis hin zur Speicherung und Darstellung der Daten in einer Cloud Anwendung entwickelt. Spezialisierte UHF-Teilentladungssensoren, mehrkanalige Transientenrekorder, galvanisch getrennte Messsysteme über Lichtwellenleiter für Messungen im Bereich hoher elektrischer Spannungen, intelligente Auswertealgorithmen, LTE-Anbindungen und spezialisierte Cloud-Lösungen sind nur ein kleiner Teil der kundenspezifischen Lösungen.
                        p Gerne entwickeln wir mit Ihnen oder für Sie individuell an Ihre Anforderungen angepasste Messtechnik. Dabei spielt es keine Rolle, ob Sie nur einen Teil der kompletten Messkette von uns benötigen oder eine Komplettlösung suchen. Sprechen Sie uns an! 
                        //    li Mehrkanalige Transientenrekorder mit individueller Anschlusstechnik und Auswertealgorithmen
                            li Teilentladungsprüfstände für Langzeitmessungen/Stückprüfungen
                            li Galvanisch getrennte Messungen über Lichtwellenleiter für EMV-Anwendungen und im Bereich hoher el. Spannungen
                            li ...
                            li sprechen Sie uns an!
                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt HFIG-600.pdf")
                        //- Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet HFIG-600.pdf")
                        Maillink(to='support@bss-hs.de', sub='Individuelle Messtechnik', text='Contact Us', size=30, strokeWidth=2)
                        //- Sitelink(to="/de/products/pdm600", text='UHF PD Monitoring System PDM-600')
                        //- Sitelink(to="/de/products/uhfsensors/overview", text='UHF PD Sensors')
                    
        //- div.margin-bottom
            
        //-     h1 Diagnostic Measurements at Transformers
        //-     p We provide different diagnostic measurements for manufacturers and operators of transformers:
        //-     p PD measurement at transformers and other equipment in the test lab or on-site in service using different PD measurement methods:
        //-     ul
        //-         li electrical PD measurement in IEC60270 range and above

        div.margin-bottom
        
        h1.product-title Beispiele:

        div.space50

        .column-container
            .column.center-content.column14
                    img.maxwidth250(src='@/assets/photos/for_product_overview/PDM-SU.png', width="100%", alt='PDM-SU', title='PDM-SU')
            .column.column34
                h1 PDM-SU
                h2.subtitle Supply Unit für unsere Teilentladungs-Monitoringgeräte
                p Die 
                    b PDM‑SU 
                    | dient als Versorgungseinheit für unsere TE‑Monitoringinstrumente. Sie kann 
                    b bis zu drei PDM‑600 oder PDM‑80 
                    | gleichzeitig mit 
                    b DC‑Versorgung
                    |, 
                    b AC‑Synchronisation 
                    | und 
                    b Ethernet‑Netzwerkverbindung 
                    | bereitstellen.
                
                p Die Einheit kann zudem einen 
                    b WLAN‑Hotspot 
                    | bereitstellen, über den sich die angeschlossenen Geräte kabellos verbinden lassen. Eine 
                    b Mobilfunkverbindung 
                    | (SIM‑Karte) ermöglicht den externen Datenzugriff oder die Integration in kundenseitige Netzwerke.

                p Die PDM‑SU wird über 
                    b 230V AC 
                    | gespeist, ist intern abgesichert und nutzt das AC‑Versorgungssignal zusätzlich für die Synchronisation.
                
        div.space50

        .column-container
            .column.center-content.column14
                img.maxwidth250(src='@/assets/photos/for_product_overview/PQM-800_freigestellt.png', width="100%", alt='Power Quality Monitor PQM-800', title='Power Quality Monitor PQM-800')
            .column.column34
                h1 PQM-800 Spannungsqualitätsmessgerät 
                h2.subtitle Mobiles Messgerät für Spannungsqualität bis 500 kHz
                p Das BSS PQM-800 ist ein 8-kanaliges Spannungsqualitätsmessgerät für die detaillierte Analyse von Spannungen und Strömen. Mit kontinuierlicher Auswertung, integriertem Speicher von bis zu 4 TB und einer intelligenten Transientenerkennung ist es maßgeschneidert für die detaillierte Charakterisierung der Spannungsqualität und zeigt insbesondere Probleme mit hochfrequenten Oberschwingungen und transienten Vorgängen zuverlässig auf.
                p Zur Bedienung, Kommunikation, und Visualisierung besitzt das PQM-800 einen integrierten Webserver, der über das integrierte WLAN oder per Fernzugriff den Vollzugriff auf die Rohdaten sowie umfangreiche Visualisierungen ermöglicht. Außerdem kann das PQM-800 mittels VPN mit der PQ-Plattform der BSS verbunden werden, so dass jederzeit auf das Gerät zugegriffen werden kann, solange es Internetzugriff hat.
                p Auf der PQ-Plattform können auch aufgezeichnete Transienten gespeichert werden, so dass sie auch dann noch ausgewertet werden können, wenn das Gerät offline ist.

                ul
                    li 1 MS/Sekunde Samplerate auf allen 8 Kanälen
                    li Oberschwingungen bis zu 500 kHz
                    li Bis zu 4 TB Speicher für jahrelange Aufnahmen mit 10-Perioden-Auflösung
                    li Cloud-Upload für sofortige Visualisierungen und permanente Erreichbarkeit

        div.space50

        .column-container
            .column.center-content.column14
                img.maxwidth250(src='@/assets/photos/services/Pulsemonitor_ausgeschnitten.png')
            .column.column34
                h1 Impulsmonitor
                h2.subtitle Mobiles Messgerät für das Monitoring von Impulsen
                p Spezialisiertes Messgerät zur Erfassung, Zählung, und Visualisierung von sporadisch auftretenden, hochfrequenten Pulsen bis in den GHz-Bereich. 
                ul
                    li 2 Puls-Zähleingänge
                    li 6 zusätzliche Eingänge für RMS-Messung zur Datenkorrelation
                    li Software-basierter Trigger ohne Rearm-Zeit
                    li Fernzugriff über integrierten Webserver mit Visualisierung, Datendownload, und Einstellungsmöglichkeiten

        div.space50

        .column-container
            .column.center-content.column14
                img.maxwidth250(src='@/assets/photos/Foto_DCMessgeraet.jpg')
            .column.column34
                h1 DC-Messgerät für Leistungstransformatoren
                h2.subtitle Messgerät für die Erfassung von DC-Sternpunktströmen 
                p Durch überregionale Erdschleifen und GIC (Geomagnetically Induced Currents) können im geerdeten Sternpunkt von Leistungstransformatoren (Quasi-) Gleichströme fließen, die den Kern vormagnetisieren und so zu erhöhten Geräuschemissionen sowie beschleunigter Alterung führen können. Mit dem DC-Messgerät können DC-Sternpunktströme dauerhaft gemessen werden. Das Auftreten von DC-Strömen kann somit mit beispielsweise Schaltzuständen, etc. korreliert werden. 


    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title Development of Customized Measurement Devices
            .subtitle Together with or for you we develop individual measurement devices adapted to your requirements such as:

        div.margin-bottom
            .column-container
                .column.center-content
                    //- Carousel(:perPage="1", autoplay=true, :autoplayTimeout="4000", loop=true, :centerMode="true", navigationEnabled=false, paginationPosition='bottom-overlay', paginationColor='rgba(255,255,255,0.4)', paginationActiveColor='#FAFAFA', adjustableHeight=false)
                    //-     Slide
                    //-         div.image-container
                    //-             picture
                    img( src='@/assets/svg/CustomDevices.svg', alt='Custom Measurement Devices', title='Custom Measurement Devices')

                    
                .column.factsandbluebox
                    .factbox
                        p In numerous research and development projects, BSS has developed measurement technology in the complete chain from sensors and A/D conversion to data storage and visualization in a cloud application. Specialized UHF partial discharge sensors, multi-channel transient recorders, galvanically isolated measurement systems via fiber optics for measurements in the range of high electrical voltages, intelligent interpretation algorithms, LTE connections and specialized cloud solutions are only a small part of the customized solutions.
                        p We are happy to develop measurement technology individually adapted to your requirements with you or for you. It doesn't matter whether you only need a part of the complete measurement chain from us or are looking for a complete solution. Please contact us!


                        //- .span.headline Examples:
                        //- ul
                        //-     li Multi-channel transient recorder with individual probes and evaluation algorithms
                        //-     li Partial discharge (PD) test benches for long-term measurements / routine tests
                        //-     li Electrically isolated measurements using optical fibers for high-voltage and EMC applications
                        //-     li ...
                        //-     li Get in touch with us!

                    .bluebox
                        Maillink(to='support@bss-hs.de', sub='Custom Devices', text='Contact Us', size=30, strokeWidth=2)
                    

        h1.product-title Examples:

        div.space50

        .column-container
            .column.center-content.column14
                    img.maxwidth250(src='@/assets/photos/for_product_overview/PDM-SU.png', width="100%", alt='PDM-SU', title='PDM-SU')
            .column.column34
                h1 PDM-SU
                h2.subtitle Supply Unit for our Partial Discharge Monitoring Instruments
                p The 
                    b PDM‑SU 
                    | serves as a supply unit for operating multiple PD monitoring systems. It supports 
                    b up to three PDM‑600 or PDM‑80 
                    | units with 
                    b DC power
                    |, 
                    b AC synchronization 
                    | and 
                    b Ethernet connectivity
                    |, enabling operation in 
                    b remote locations 
                    | without existing infrastructure.

                p A built‑in 
                    b Wi‑Fi Hotspot 
                    | allows wireless access to connected devices. In addition, a 
                    b cellular connection via SIM card 
                    | enables remote data access or integration into customer networks.
                
                p The unit is powered by 
                    b 230V AC
                    |, includes an internal fuse, and uses the AC supply signal for synchronization.

        div.space50

        .column-container
            .column.center-content.column14
                img.maxwidth250(src='@/assets/photos/for_product_overview/PQM-800_freigestellt.png', width="100%", alt='Power Quality Monitor PQM-800', title='Power Quality Monitor PQM-800')
            .column.column34
                h1 PQM-800 Power Quality Monitor
                h2.subtitle High-Frequency Power Quality Monitor
                p The PQM-800 is a power quality monitoring system made for detailed analysis of voltages and currents over long periods of time. With a 1 MS/s sample rate on 8 channels, continuous evaluation of harmonics up to 500 kHz and an intelligent transient detection, the PQM-800 is built to find problems with high frequency harmonics and transient phenomena in power systems or single devices and plants.
                p For control, communication, and visualization, the PQM-800 has an integrated webserver, which allows complete control and access over the integrated Wi-Fi or via LAN. It can also be securely connected to the BSS Monitoring Cloud using a VPN.
                p The PQM-800 is available with 4x 600 V 4mm plug inputs and 4x 50 V BNC inputs for measurements in low voltage grids (see picture), or with 8x 50 V BNC inputs for usage with voltage dividers and sensors.

                ul
                    li 1 MS/second sample rate on all 8 channels
                    li 500 kHz Harmonics
                    li Up to 4 TB storage for year-long recordings with 10-period-resolution
                    li Cloud upload for immediate Visualization and permanent availability

        div.space50

        .column-container
            .column.center-content.column14
                img.maxwidth250(src='@/assets/photos/services/Pulsemonitor_ausgeschnitten.png')
            .column.column34
                h1 Pulsemonitor
                h2.subtitle Mobile Measurement Device for Pulse Monitoring
                p Specialized monitoring device for counting, recording, and visualization of sporadically occurring, high frequency pulses up to the GHz range.
                ul
                    li 2 Pulse monitoring inputs
                    li 6 additional inputs for RMS measurements for data correlation
                    li Software-based trigger without rearm time
                    li Remote access via integrated webserver including visualization, download, and configuration

        div.space50

        .column-container
            .column.center-content.column14
                img.maxwidth250(src='@/assets/photos/Foto_DCMessgeraet.jpg')
            .column.column34
                h1 DC measurement for power transformers
                h2.subtitle Monitoring device for the recording of DC neutral point currents
                p Interregional ground loops and GIC (geomagnetically induced currents) can lead to (quasi-) DC currents through the neutral point of power transformers, which can premagnetize the core and cause noise emissions and accelerated ageing. With the DC measurement device, these neutral point DC current can be monitored continuously. Neutral point currents can then be correlated with switching states etc.

</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
    components: {
        Carousel,
        Slide,
    },
    meta: {
        de: {
            title: "BSS - Dienstleistungen - Individuelle Messtechnik",
            description:
                "Entwicklung von individueller Messtechnik von Sensorik bis zur Visualisierung und zum Cloud-Upload",
        },
        en: {
            title: "BSS - Services - Custom Measurement Devices",
            description:
                "Development of individual Measurement Devices from Sensors to Visualization and Cloud Upload",
        },
    },
};
</script>

<style lang='sass' scoped>
div.space50
    height: 50px

img
    max-width: 100%

.maxwidth250
    max-width: 200px

.image-container
    overflow: hidden
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    object-fit: cover
    @media(min-width: $mobile-breakpoint)
        height: 100%
    @media(max-width: $mobile-breakpoint)
        max-height: 200px

    .carousel-image
        margin: 2px
        @media(min-width: $mobile-breakpoint)
            width: 100%
        @media(max-width: $mobile-breakpoint)
            max-height: 200px

.twocolumns
    display: flex
</style>